/**
 * ToolbarGroup.js
 * Groups toolbar items
 *
 * @class   ToolbarGroup
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

	displayName: 'ToolbarGroup',

	propTypes: {
		align: React.PropTypes.oneOf(['left', 'right', 'center'])
	},

	getDefaultProps() {
		return {
			align: 'left'
		};
	},

	render() {

		var classes = ClassNames(this.props.className, {
			'lui-toolbar-group': true,
			'lui-pull-left': this.props.align === 'left',
			'lui-pull-right': this.props.align === 'right',
			'lui-center': this.props.align === 'center'
		});

		return (
			<div className={classes}>{this.props.children}</div>
		);
	}

})



/** WEBPACK FOOTER **
 ** ./src/components/toolbar/ToolbarGroup.js
 **/